import { Collector } from '@debbie/common/dist/collectors/index.js'
import { c } from '@debbie/cortex/dist/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import THEME from '@debbie/iris/dist/theme.js'
import React from 'react'
import { useSelector } from 'react-redux'
import { styled } from 'styled-components'

import { APIBASE } from '../config.js'
import LanguageSelector from './LanguageSelector.js'

interface Props {
  collector: Collector | null
}

const CaseFooter = (props: Props) => {
  const { collector } = props
  const lang = useSelector((s: RootState) => s.lang)

  return (
    <Footer>
      {collector && (
        <ul>
          <li>
            <a onClick={() => c.auth.logout()}>{lang.debtorWebHome.logout}</a>
          </li>
          {collector.privacyPolicy != null && (
            <li>
              <a target="_blanc" href={collector.privacyPolicy}>
                {lang.debtorWebHome.privacyPolicy}
              </a>
            </li>
          )}
          {collector.businessTerms != null && (
            <li>
              <a target="_blanc" href={collector.businessTerms}>
                {lang.debtorWebHome.businessTerms}
              </a>
            </li>
          )}
          <li>{collector.name}</li>
          {collector.centralRegisterId != null && (
            <li>CVR: {collector.centralRegisterId}</li>
          )}
          {collector.address &&
            collector.address.address &&
            collector.address.zipcode &&
            collector.address.city && (
              <li>
                {collector.address.address}, {collector.address.zipcode}{' '}
                {collector.address.city}
              </li>
            )}
        </ul>
      )}
      <LanguageSelector />
      {collector?.logo != null && (
        <img
          alt={collector.logo.fileName ?? ''}
          src={`${APIBASE}/files/${collector.logo.fileId}/${collector.logo.fileName}`}
        />
      )}
    </Footer>
  )
}

export default CaseFooter

const Footer = styled.div`
  margin-top: 80px;
  margin-bottom: 40px;
  font-size: 0.9em;

  ul {
    margin: 0;
    padding: 0;
    text-align: center;
    font-weight: 700;

    li {
      display: inline-block;
      margin-right: ${THEME.GRID_SPACING}px;
      position: relative;

      a {
        text-decoration: underline;
        color: inherit;
        cursor: pointer;
      }

      &:after {
        content: '-';
        position: absolute;
        right: ${-THEME.GRID_SPACING / 2 - 3}px;
      }

      &:last-child:after {
        display: none;
      }
    }
  }

  img {
    max-width: 150px;
    margin: 0 auto;
    display: block;
    margin-top: 30px;
  }
`
